import React from 'react';
import { Building2, ShoppingBag, Factory, Home, ArrowRight } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';
import { Button } from './ui/button';
import { companies } from '../mock';

const Companies = () => {
  const getCompanyIcon = (name) => {
    if (name.includes('Moda')) return ShoppingBag;
    if (name.includes('Montreal')) return Factory;
    if (name.includes('Construtora')) return Home;
    return Building2;
  };

  const getCategoryColor = (category) => {
    switch (category) {
      case 'Varejo': return 'bg-blue-100 text-blue-800';
      case 'Industrial': return 'bg-green-100 text-green-800';
      case 'Construção Civil': return 'bg-orange-100 text-orange-800';
      default: return 'bg-slate-100 text-slate-800';
    }
  };

  return (
    <section id="empresas" className="py-20 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-slate-900 mb-4">
            Nossas Empresas
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto leading-relaxed">
            O Grupo Martins Ribeiro atua em diferentes segmentos, sempre mantendo 
            a excelência e os valores familiares em cada empreendimento.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {companies.map((company, index) => {
            const Icon = getCompanyIcon(company.name);
            
            return (
              <Card 
                key={company.id}
                className="group hover:shadow-xl transition-all duration-300 transform hover:scale-105 bg-white border-0 shadow-lg animate-in fade-in-0 duration-1000"
                style={{ animationDelay: `${index * 200}ms` }}
              >
                <CardHeader className="pb-4">
                  <div className="flex items-start justify-between">
                    <div className="flex items-center space-x-3">
                      <div className="w-12 h-12 bg-slate-100 rounded-lg flex items-center justify-center group-hover:bg-slate-800 group-hover:text-white transition-all duration-300">
                        <Icon className="w-6 h-6" />
                      </div>
                      <div>
                        <CardTitle className="text-xl font-semibold text-slate-900 group-hover:text-slate-800 transition-colors duration-300">
                          {company.name}
                        </CardTitle>
                      </div>
                    </div>
                    <Badge className={getCategoryColor(company.category)}>
                      {company.category}
                    </Badge>
                  </div>
                </CardHeader>

                <CardContent className="space-y-4">
                  <p className="text-slate-600 leading-relaxed">
                    {company.description}
                  </p>

                  <div className="space-y-2">
                    <h4 className="font-semibold text-slate-800">Principais Serviços:</h4>
                    <div className="flex flex-wrap gap-2">
                      {company.services.map((service, serviceIndex) => (
                        <span
                          key={serviceIndex}
                          className="px-3 py-1 bg-slate-100 text-slate-700 text-sm rounded-full hover:bg-slate-200 transition-colors duration-200"
                        >
                          {service}
                        </span>
                      ))}
                    </div>
                  </div>

                  <div className="pt-4 border-t border-slate-100">
                    <Button 
                      variant="ghost" 
                      className="w-full justify-between text-slate-700 hover:text-slate-900 hover:bg-slate-100 transition-all duration-200 group/btn"
                    >
                      Saiba Mais
                      <ArrowRight className="w-4 h-4 group-hover/btn:translate-x-1 transition-transform duration-200" />
                    </Button>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Call to Action */}
        <div className="mt-16 text-center">
          <div className="bg-white p-8 rounded-2xl shadow-lg max-w-2xl mx-auto">
            <h3 className="text-2xl font-bold text-slate-900 mb-4">
              Interessado em Parcerias?
            </h3>
            <p className="text-slate-600 mb-6 leading-relaxed">
              Estamos sempre abertos a novas oportunidades de negócio e parcerias 
              estratégicas que agreguem valor ao nosso grupo.
            </p>
            <Button 
              onClick={() => {
                const element = document.getElementById('contato');
                if (element) element.scrollIntoView({ behavior: 'smooth' });
              }}
              size="lg"
              className="bg-slate-800 hover:bg-slate-900 text-white px-8 py-3 text-lg font-semibold rounded-lg transition-all duration-200 transform hover:scale-105 group"
            >
              Entre em Contato
              <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform duration-200" />
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Companies;